var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 115,
    viewBox: "0 0 138 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 18.6667C25.4288 18.6667 16.5 27.5955 16.5 38.1667C16.5 48.7378 25.4288 57.6667 36 57.6667C46.5712 57.6667 55.5 48.7378 55.5 38.1667C55.5 27.5955 46.5712 18.6667 36 18.6667ZM36 53.3333C27.7797 53.3333 20.8333 46.387 20.8333 38.1667C20.8333 29.9463 27.7797 23 36 23C44.2203 23 51.1667 29.9463 51.1667 38.1667C51.1667 46.387 44.2203 53.3333 36 53.3333Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1654 36V27.3333H33.832V40.3333H46.832V36H38.1654Z",
    fill: "#565656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4492 18.0318L50.5085 14.9638L57.0302 21.4638L53.9687 24.534L47.4492 18.0318Z",
    fill: "#565656"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5116 18.0318L18.0333 24.5297L14.9609 21.4703L21.4393 14.9703L24.5116 18.0318Z",
    fill: "#565656"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94 115C69.6995 115 50 95.3005 50 71C50 46.6995 69.6995 27 94 27C118.301 27 138 46.6995 138 71C138 95.3005 118.301 115 94 115Z",
    fill: "#27AE60"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6774 95.4597C85.7509 95.4597 83.8245 94.634 82.7236 92.9828L67.3117 73.1674C65.1099 70.4153 65.6605 66.5623 68.4126 64.3605C71.1647 62.1588 75.0176 62.7093 77.2194 65.4614L87.6774 78.9469L110.796 48.9485C112.997 46.1964 116.85 45.6458 119.602 47.8476C122.355 50.0494 122.905 53.9024 120.703 56.6544L92.6313 92.9827C91.2553 94.359 89.604 95.4597 87.6774 95.4597Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleClockIcon);
export default __webpack_public_path__ + "static/media/check-circle-clock-icon.17881acf3afbc52649986efa64bddb22.svg";
export { ForwardRef as ReactComponent };